const { expect } = require('chai');
const { migratortronApi } = require('./migratortronApi');
const { loadRecordedMock } = require('./util');

const projectId = 'migratortronTarget';

describe('Migrate components', () => {
  describe('preview migrating a single component', () => {
    const mock = loadRecordedMock('migrate_components_simple_preview.json');

    it(`should return one component to create`, (done) => {
      migratortronApi.post(
        'migrate/components?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.false;

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['plainComponent']).to.equal('create');
          done();
        }
      );
    });
  });

  describe('migrate a single component', () => {
    const mock = loadRecordedMock('migrate_components_commit_simple.json');

    it(`should create one component`, (done) => {
      migratortronApi.post(
        'migrate/components/commit?simple',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          expect(components['plainComponent']).to.equal('create');

          done();
        }
      );
    });
  });

  describe('repeat the same migrate a single component', () => {
    const mock = loadRecordedMock(
      'migrate_components_commit_simple_repeat.json'
    );

    it(`should return one component`, (done) => {
      migratortronApi.post(
        'migrate/components/commit?simple&repeat',
        { body: mock.payload },
        (error, response, body) => {
          if (error) done(error);

          expect(body).to.be.an('object');
          if (body.error) done(body.error);
          expect(body.errors).to.not.exist;

          expect(body.committed).to.be.true;

          expect(body.components).to.be.an('object');
          expect(body.components[projectId]).to.be.an('object');
          const components = body.components[projectId];
          // This does an update because it is done using "simple" migration service
          expect(components['plainComponent']).to.equal('update');

          done();
        }
      );
    });
  });
});
